export enum StorageKeys {
  USERDATA = 'TROCATURNO_USER',
  TOKEN = 'TROCATURNO_TOKEN',
  USERADMIN = 'TROCATURNO_USERADMIN',
  EMPRESAS_DATA = 'TROCATURNO_EMPRESAS',
  ESCALAS_DATA = 'TROCATURNO_ESCALAS',
  LOCALES_DATA = 'TROCATURNO_LOCAIS',
  COLABORADORES_DATA = 'TROCATURNO_COLABS',
  EMPRESA_DATA = 'TROCATURNO_EMPRESA'
}
